<template>
  <v-list shaped>
    <v-list-group
      @click.stop
      v-for="item in computedLinks"
      :key="item.id"
      v-model="item.active"
      append-icon=""
      no-action
    >
      <template v-slot:activator>
        <v-list-item  @click="selected(item)"  v-bind="item.linkProps" >
          <v-list-item-icon>
            <v-icon color="warning">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon v-if="item.to === ''">
            <v-icon >mdi-chevron-right</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </template>

      <v-list-item
        v-for="subItem in item.menumodel"
        :key="subItem.title"
        :to="subItem.to"
        @click="selected(subItem)"
      >
        <v-list-item-icon>
          <v-icon color="warning">{{ subItem.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ subItem.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-group>
  </v-list>
</template>

<script>
export default {
  name: "DefaultList",

  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    active: [],
    
  }),

  computed: {
    computedLinks() {
      return this.items.map(link => {
        const isExternalLink = url => /^((https?:)?\/\/)/.test(url)
        const linkProps = {
          [isExternalLink(link.to) ? 'href' : 'to']: link.to,
        }
        
        if (link.to.includes("http")) {
          linkProps.target = '_blank'
        }
        return {
          ...link,
          linkProps,
        }
      })
    },
  },
  methods: {
    selected(item) {
      
      if (item.to === "")
        return;
      
      
      let id = item.id;
      localStorage.setItem("mid",id);
    },
  },
};
</script>
